<template>
    <v-navigation-drawer stateless value="true" dark>
        <v-list>
            <v-list-item :to="nav.url" v-for="nav of navigation" :key="Math.random()">
                <v-list-item-action>
                    <v-icon>{{ nav.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-title>{{ nav.title }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
    export default {
        name: 'headNavigation',
        data: () => ({
            navigation: [
                {
                    title: 'Главная',
                    icon: 'home',
                    url: '/'
                },
                {
                    title: 'Пользователи',
                    icon: 'supervised_user_circle',
                    url: '/head/user'
                },
                {
                    title: 'Заказы',
                    icon: 'shopping_cart',
                    url: '/head/statistic/order'
                },
                // { title: 'Бронирование', icon: 'import_contacts', url: '/head/statistic/booking' },
                {
                    title: 'Клиенты',
                    icon: 'group',
                    url: '/head/statistic/customer'
                },

                {
                    title: 'Продукты',
                    icon: 'subject',
                    url: '/head/statistic/products'
                },

                {
                    title: 'Логи',
                    icon: 'subject',
                    url: '/head/statistic/logs'
                },
            ]
        })
    }
</script>
